// react library imports
import { useNavigate } from 'react-router-dom';

// style imports
import './PreFooter.css';

const PreFooter = ({className, title, testId}) => {
  // define navigate from react-router-dom
  const navigate = useNavigate()

  // handle navigation
  const handleNavigation  = () =>{
    return navigate('/register', {relative:"path"})
  }
  return (
    <div className={`mues_column_space_between pre_footer_container ${className}`}
    data-testid={testId}>
        <div className="custom-shape-divider-top-1712987950">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" 
              className="shape-fill"></path>
          </svg>
        </div>
        {/* <div/> */}
        <h1 className='mues_white mues_font_size_46 mues_font_weight_700 
        mues_text_align_center'>
          {title}
        </h1>
        <div className='mues_row_center pre_footer_button'>
            <button className='btn main_button blue_btn'
            onClick={handleNavigation}>
                Get Started
            </button>
        </div>
    </div>
  )
}

export default PreFooter;